import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api'
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AddStockTransfer$Params } from 'src/api/generated/fn/inventory/add-stock-transfer';
import { GetInventories$Params } from 'src/api/generated/fn/inventory/get-inventories';
import { GetInventory$Params } from 'src/api/generated/fn/inventory/get-inventory';
import { GetInventoryStockItems$Params } from 'src/api/generated/fn/inventory/get-inventory-stock-items';
import { InventoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-dto';
import { InventoryStockDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Inventory/inventory-stock-dto';
import { AddInventoryStockTransferDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/InventoryStockTransfers/add-inventory-stock-transfer-dto';
import { UserDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/User/user-dto';
import { InventoryService } from 'src/api/generated/services';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';import { AddOrEditInventoryItemComponent } from '../../add-or-edit-inventory-item/add-or-edit-inventory-item.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-new-outgoing-transfer',
  templateUrl: './new-outgoing-transfer.component.html',
  styleUrls: ['./new-outgoing-transfer.component.scss']
})
export class NewOutgoingTransferComponent implements OnInit, OnDestroy {

  venueId: string;
  inventoryId: string;
  venueIdUpdateSubscription: Subscription;
  todaysDate: Date;
  inventory: InventoryDto;

  stockItemsList: Array<InventoryStockDto> =  new Array<InventoryStockDto>();  
  destinationInventories: Array<InventoryDto> = new Array<InventoryDto>();
  destinationInventory: InventoryDto;
  user: UserDto | null;
  unsubscribe: Subject<void> = new Subject<void>();
  form: FormGroup;

  constructor(private authenticationService: AuthenticationService,
              private route: ActivatedRoute,
              private router: Router,
              private formBuilder: FormBuilder,
              private currentVenueHelper: CurrentVenueHelperService,
              private inventoryService: InventoryService,
              private confirmationService: ConfirmationService,
              public translate: TranslateService,
              private messageService: MessageService,
              public dialogService: DialogService
              ) { 
                
    this.authenticationService.loginUser.subscribe(user => {
        this.authenticationService.getProfile(user?.roles).subscribe(response => this.user = response);
    });
  }

  ngOnInit(): void {
    this.createForm();
    this.todaysDate = new Date();
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
      if (params['inventory-id'] != null) {
        this.inventoryId = params['inventory-id'];

        const inventoryParams: GetInventory$Params = { inventoryId: this.inventoryId };
        this.inventoryService.getInventory(inventoryParams).subscribe(response => this.inventory = response);

        const getInventoriesParams: GetInventories$Params = { venueId: this.venueId, isRemoved: false };
        this.inventoryService.getInventories(getInventoriesParams).subscribe(response => {
          this.destinationInventories = response.inventories ? response.inventories : [];
          this.destinationInventories = this.destinationInventories.filter(i => i.id != this.inventoryId);
        });
        this.getStockItems();
      }
    });
  }
  private createForm(): void {  
    this.form = this.formBuilder.group({ 
      destinationInventory: new FormControl('', {  
        validators: [Validators.required]  
      }),  
      items: this.formBuilder.array([  
            this.createTableRow()  
        ])  
    })  
  }  
  private createTableRow(): FormGroup {  
    return this.formBuilder.group({  
        item: new FormControl('', {  
            validators: [Validators.required]  
        }),  
        quantitySent: new FormControl('', {  
            validators: [Validators.required]  
        }) 
    });   
  } 

  getItemControls(index: number){
    return (this.items.controls[index] as FormGroup)
  }

  addNewRow(): void {  
    this.items.push(this.createTableRow());  
  } 

  get items(): FormArray {  
    return this.form.get('items') as FormArray;  
  } 
  
  onDeleteRow(rowIndex:number): void {  
    this.items.removeAt(rowIndex);  
  }  

  navigateToMain(){
    if(this.inventory.isMain){
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 3 }}); 
    }else{
      this.router.navigate([this.venueId, "inventory", this.inventoryId], { queryParams: { activeIndex: 2 }}); 
    }
  }
  addNewInventoryItem() {
    const ref = this.dialogService.open(AddOrEditInventoryItemComponent, {
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((response: any) => {
      if (response) {
        this.getStockItems();
        this.messageService.add({ severity: 'success', summary: 'Item was successfully added!', life: 3000 });
      } else if (response == false) {
        this.messageService.add({ severity: 'error', summary: 'Error occurred!', life: 3000 });
      }
    });
  }
  getStockItems(){
    const stockItemsParams: GetInventoryStockItems$Params = { inventoryId: this.inventoryId };
    this.inventoryService.getInventoryStockItems(stockItemsParams).subscribe( response => {this.stockItemsList = response.stockItems ? response.stockItems : [];  this.createForm(); } );
  }

  issueTransfer(){
    if(this.form.valid){
      this.confirmationService.confirm({
        header: this.translate.instant('TRANSFER.CONFIRMATION_DIALOG_CREATE_TRANSFER_TITLE'),
        message: this.translate.instant('TRANSFER.CONFIRMATION_DIALOG_CREATE_TRANSFER_QUESTION'),
        acceptLabel: this.translate.instant('YES'),
        rejectLabel: this.translate.instant('NO'),
        defaultFocus: "reject",
        acceptButtonStyleClass: 'soc-confirmation-dialog dialog-btn constructive-btn',
        rejectButtonStyleClass: 'soc-confirmation-dialog dialog-btn reject-btn',
        accept: () => {
          const transferDto: AddInventoryStockTransferDto = { destinationInventory: this.form.getRawValue()['destinationInventory'], lineItems: this.items.getRawValue()}
          const params: AddStockTransfer$Params = { inventoryId: this.inventoryId, body: transferDto};
          this.inventoryService.addStockTransfer(params).subscribe({
            next: response => {
              this.messageService.add( { severity: 'success', summary: 'The transfer was successfully issued!', life: 3000 } );
              this.navigateToMain();
            },
            error: errorResponse => this.messageService.add( { severity: 'error', summary: 'Error occurred!', life: 3000 } )
          });
        }
      });
    }
  } 
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}
